const comments = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20portrait%20young%20person%20with%20headphones%20simple%20background%20soft%20lighting%20warm%20tones%20circular%20frame%20friendly%20expression&width=120&height=120&seq=avatar-user-1&orientation=squarish',
    name: '星际旅人',
    time: '3 天前',
    comic: '《银河远征队》第 127 话',
    text: '星球漫画的下拉式阅读体验真的太棒了！不用手动翻页，一口气看了五十话停不下来。画质也很清晰，比我在其他平台看的体验好太多了。',
    likes: 342,
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20portrait%20woman%20with%20glasses%20smiling%20simple%20warm%20background%20soft%20lighting%20circular%20frame&width=120&height=120&seq=avatar-user-2&orientation=squarish',
    name: '银河漫游指南',
    time: '5 天前',
    comic: '《星球大战：新纪元》第 89 话',
    text: '作为一个十年的科幻漫画迷，星球漫画的更新速度让我惊喜。每天早上都能看到最新章节更新，而且分类很全，星际、宇宙、太空冒险全都有。强烈推荐给所有科幻同好！',
    likes: 287,
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20portrait%20teenager%20with%20cap%20casual%20expression%20simple%20background%20warm%20lighting%20circular%20frame&width=120&height=120&seq=avatar-user-3&orientation=squarish',
    name: '星空下的读者',
    time: '1 周前',
    comic: '《深空迷航》第 56 话',
    text: '朋友推荐的星球漫画，没想到这里有这么多好看的科幻漫画！排行榜功能也很实用，帮我发现了好几部之前不知道的优秀作品。现在每天通勤路上必刷。',
    likes: 156,
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            读者热评
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            来自星际漫画迷的真实阅读反馈
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 rounded-lg p-4 md:p-5 border border-background-200/60"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                      {comment.name}
                    </h3>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">
                      {comment.time}
                    </span>
                  </div>
                  <p className="text-xs text-accent-600 mt-0.5 whitespace-nowrap truncate">
                    {comment.comic}
                  </p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                {comment.text}
              </p>
              <div className="flex items-center gap-1 text-foreground-400 text-xs">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-heart-line"></i>
                </span>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}